<template>
  <div v-if="currentChecklist">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom de la checklist</span>
                  </td>
                  <td>
                    {{ currentChecklist.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentChecklist.created_by.prenom
                        ? currentChecklist.created_by.prenom +
                          ' ' +
                          currentChecklist.created_by.nom
                        : currentChecklist.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="currentChecklist.statut"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      id: null,
    };
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
  },
};
</script>

<style scoped></style>
